class VeridzStickyBuy extends HTMLElement {
  connectedCallback() {
    this.main = document.querySelector('product-info[id^="MainProduct-"]');
    if (!this.main) return;
    this.button = this.querySelector('[data-sticky-submit]');
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.main, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    const buy = this.main.querySelector('product-form');
    if (buy) {this.intersection = new IntersectionObserver(([entry]) => {this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;}, {threshold:0}); this.intersection.observe(buy);}
    this.sync();
  }
  sync() {
    const submit = this.main.querySelector('product-form button[name="add"]');
    const formId = submit?.closest('form')?.getAttribute('id');
    if (formId) {
      this.button.type = 'submit';
      this.button.setAttribute('form', formId);
    }
    this.button.disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    this.button.textContent = submit?.querySelector('span')?.textContent.trim() || 'Choose options';
    const sale = this.main.querySelector('.price--on-sale .price__sale .price-item--sale');
    const price = sale || this.main.querySelector('.price__regular .price-item--regular');
    this.querySelector('[data-sticky-price]').textContent = price?.textContent.trim() || '';
  }
  disconnectedCallback() {this.observer?.disconnect();this.intersection?.disconnect();}
}
if (!customElements.get('veridz-sticky-buy')) customElements.define('veridz-sticky-buy', VeridzStickyBuy);
